const state = {
  bgSetting: true,
  userdata: null,
  districtstate: null,
};

export default state;
